import { ReservationReferenceIdentifier } from '@mews-commander/data-access';
import { Stack } from '@optimus-web/core';
import { TextKey, FeatureFlag } from '@mews-commander/enums';
import { LocalizedLabel, LocalizedTypography, SpacedColon } from '@mews-commander/ui';
import { useFeatureFlag } from '@mews/framework';
import { ReservationReferenceLinks } from '../ReservationReferenceLinks';

interface Props {
    reservations?: ReservationReferenceIdentifier[] | null;
}

export const PaymentMethodStatusHistoryBodyReservations = ({ reservations }: Props) => {
    const isPaymentPlanEnabled = useFeatureFlag(FeatureFlag.paymentPlanEnabled);

    if (!isPaymentPlanEnabled) {
        return null;
    }

    const hasReservations = reservations && reservations.length > 0;

    return (
        <Stack>
            <LocalizedLabel textKey={TextKey.PaymentMethodHistoryReservationReferences} variant="secondary" as="div" />
            {SpacedColon}
            {hasReservations ? (
                <ReservationReferenceLinks reservations={reservations} />
            ) : (
                <LocalizedTypography
                    as="span"
                    textKey={TextKey.PaymentMethodHistoryValueNoReservationReferences}
                    textStyle="bodyMedium"
                />
            )}
        </Stack>
    );
};
